module.exports = __webpack_public_path__ + "assets/dialpad.a6073564.png";